import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api"
import { checkResponseError } from '../../../../Services/Utils'
import { connect } from 'react-redux';
import * as R from 'ramda';
import { Redirect } from 'react-router-dom'
import AuthAction from '../../../../Redux/AuthRedux' 
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import FormBank from "./formBank";
import DDLCompany from '../../../../modules/commons/DDLCompany';

import Button from '../../../../modules/commons/Button';
const UtilsButtonLogin = require('../../../../Services/UtilsButtonLogin');

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class Bank extends Component {
    constructor() {
        super()
        this.state = {
            rawData: [],
            dataTable: [
                { 
                "Bank Code": "SAA21", 
                "Bank Name": "HAHAHA Bank", 
                "Account Number": "1313131", 
                "Address": "Jalan jalan", 
                "Kecamatan": "kuningan",
                "Kota": "Kocak lu", 
                "Provinsi": "Jawa Barat", 
                "KodePos": "11451", 
                "Phone Number": "22424242", 
                "Nama Dealer": "Jopan Deal or no deal",
                "Status": "Active",
                "Integration": "Yes"
            },
            {
                "Bank Code": "BCA01",
                "Bank Name": "Bank Central Asia",
                "Account Number": "88888888",
                "Address": "Jalan Sudirman",
                "Kecamatan": "Setiabudi", 
                "Kota": "Jakarta",
                "Provinsi": "DKI Jakarta",
                "KodePos": "12920",
                "Phone Number": "021-1500188",
                "Nama Dealer": "Toko Maju Jaya",
                "Status": "Active",
                "Integration": "No" 
              },
              
              {
                "Bank Code": "MANDIRI02",
                "Bank Name": "Bank Mandiri",
                "Account Number": "99999999", 
                "Address": "Jalan Thamrin",
                "Kecamatan": "Tanah Abang",
                "Kota": "Jakarta Pusat",
                "Provinsi": "DKI Jakarta",
                "KodePos": "10120",
                "Phone Number": "1500188",
                "Nama Dealer": "Toko Makmur",
                "Status": "Inactive",
                "Integration": "Yes"
              },
              
              {
                "Bank Code": "BNI03",
                "Bank Name": "Bank BNI",
                "Account Number": "1212121212",
                "Address": "Jalan Diponegoro",
                "Kecamatan": "Cilandak",
                "Kota": "Jakarta Selatan",
                "Provinsi": "DKI Jakarta",
                "KodePos": "12430",
                "Phone Number": "021-5251888",
                "Nama Dealer": "Dealer Jaya",
                "Status": "Active",
                "Integration": "No"
              },
              {
                "Bank Code": "BTN04", 
                "Bank Name": "Bank Tabungan Negara",
                "Account Number": "1010101010",
                "Address": "Jalan Gajah Mada", 
                "Kecamatan": "Senen",
                "Kota": "Jakarta Pusat",
                "Provinsi": "DKI Jakarta",
                "KodePos": "10430",
                "Phone Number": "021-3890909",
                "Nama Dealer": "Toko Sukses",
                "Status": "Active",
                "Integration": "Yes"
              },
              
              {
                "Bank Code": "BRI05",
                "Bank Name": "Bank Rakyat Indonesia",
                "Account Number": "2020202020",
                "Address": "Jalan Hayam Wuruk",
                "Kecamatan": "Kebayoran Baru",
                "Kota": "Jakarta Selatan",
                "Provinsi": "DKI Jakarta", 
                "KodePos": "12120",
                "Phone Number": "021-5251818",
                "Nama Dealer": "Dealer Maju",
                "Status": "Inactive",
                "Integration": "No"  
              },
              
              {
                "Bank Code": "MANDIRI06",
                "Bank Name": "Bank Mandiri Syariah",
                "Account Number": "3030303030",
                "Address": "Jalan MH Thamrin",
                "Kecamatan": "Menteng",
                "Kota": "Jakarta Pusat",
                "Provinsi": "DKI Jakarta",
                "KodePos": "10340", 
                "Phone Number": "021-2345678",
                "Nama Dealer": "Dealer Mulia",
                "Status": "Active",
                "Integration": "Yes"
              }
              
              
            
            ],
            selectedIndex: [],
            createVisible: false,
            updateVisible: false,
            deletePopUpVisible: false,
            savePopUpVisible: false,
            loadSave: false,
            allowResize: false,
            defaultSize: 0,
            minSize: 0,
            maxSize: 0,
            timeout: 1000 * 100 * 9,
            isTimedOut: false,
            toCount: 0,
            table_limit: 10,
            table_page: 0,
            table_query: "",
            createVisible2: false,
            tabIndex: 0,
            checkTab: false,
            data: {},
            dataDto: {},
            buttonAccess: {}
        }
        this.idleTimer = null
    }

    logout() {
        this.props.authLogout()
        return <Redirect to={{ pathname: "/" }} />
    }

    onAction() {
        this.setState({ isTimedOut: false })
    }

    onActive() {
        this.setState({ isTimedOut: false })
    }

    onIdle() {
        const isTimedOut = this.state.isTimedOut
        if (isTimedOut) {
            alert("Your session has timed out. Please log in again")
            this.logout()
        } else {
            this.idleTimer.reset();
            this.setState({ isTimedOut: true })
        }
    }

    componentDidMount() {
        UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
            // console.log("ORI ", response);
            this.setState({
                buttonAccess: response
            }, () => {
                this.getCountPage(this.state.table_page, this.state.table_limit);
            })
        })
    }

    getCountPage = async (page, limit) => {
        console.log('getCountPage')
        let payload = {
            // limit: limit, 
            // offset: page,
            // filter: this.state.table_query,
            // companyId: this.state.dataDto.companyId,
            // companyGroupId: null,
            // category: null,
            // isActive: null,
            // sortBy: this.state.dataDto.sortBy ?? "",
            // orderBy: this.state.dataDto.orderBy ?? "",
        } 
        console.log(payload)

        let res = await API.create('LOCAL_BANK').getBank(payload)
        if (res.ok) {
            console.log('here')
            if (res.data.data === null) {
                this.setState({ dataTable: [] })
            } else {
                // console.log(JSON.stringify(res.data.data, null, 2));
                let dataTable = res.data.data && res.data.data.map((value) => {
                    const { bankcode, bankname, accountnumber, address, kecamatan, kota, provinsi, kodepos, phonenumber, namadealer, integration, status } = value;
                    return [
                        bankcode,
                        bankname,
                        accountnumber,
                        address,
                        kecamatan,
                        kota,
                        provinsi,
                        kodepos,
                        phonenumber,
                        namadealer,
                        integration,
                        status?"ACTIVE":"NONACTIVE",
                    ];
                });
                console.log('datatable', dataTable)
                this.setState({
                    rawData: res.data.data && res.data.data.listUser,
                    dataTable,
                    toCount: res.data.data && res.data.data.dataOfRecord
                })
                this.onFinishFetch();
            }
        } else{
            console.log('error')
        }
    }

    handleClearUser = (e) => {
        this.setState({
            table_page: 0,
            toCount: 0,
            data: {},
            dataDto: {},
        }, () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
        })
    }

    handleSearch = (eventSearch) => {
        this.setState({
            table_page: 0,
            dataDto: eventSearch ? this.state.data : this.state.dataDto,
        }, () => {
            this.getCountPage(this.state.table_page, this.state.table_limit)
        })
    }

    isLoad(visible) {
        this.setState({ loadSave: visible })
    }

    checkResponse(res, type) {
        if (res.ok && res.data.status === "S") {
            type === 'delete' && this.setState({ deletePopUpVisible: false })
            setTimeout(() => {
                this.openSavePopUp()
            }, 500);
        } else {
            this.isLoad(false)
            checkResponseError(res)
        }
    }

    handleSubmit = async (response) => {
        this.checkResponse(response)
    }

    handleDelete = async () => {
        this.isLoad(true);
        let payload = { ...this.state.rawData[this.state.selectedIndex] }
        payload.action = "DELETE";

        let response = await API.create('MASTERDATA_EKSAD').postSaveUser(payload)
        this.checkResponse(response, 'delete')
        this.isLoad(false);
    }

    handlePopUp = () => {
        this.handleSearch();
        this.setState({
            savePopUpVisible: false,
            createVisible: false,
            createVisible2: false
        })
    }

    startFetch = () => {
        this.LoadingBar.continousStart();
    };

    onFinishFetch = () => {
        if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
    };

    openCreateForm = () => {
        this.setState({ createVisible: !this.state.createVisible })
    };

    openUpdateForm = () => {
        this.setState({ updateVisible: !this.state.updateVisible })
    };

    openSavePopUp = () => {
        this.setState({ savePopUpVisible: !this.state.savePopUpVisible, loadSave: false })
    };

    openDeletePopup = (index) => {
        this.setState({ deletePopUpVisible: !this.state.deletePopUpVisible, selectedIndex: index })
    };

    columnsUser = [
        { name: "Bank Code" },
        { name: "Bank Name" },
        { name: "Account Number" },
        { name: "Address" },
        { name: "Kecamatan" },
        { name: "Kota" },
        { name: "Provinsi" },
        { name: "KodePos" },
        { name: "Phone Number" },
        { name: "Nama Dealer" },
        { name: "Integration"},
        { name: "Status" },
        {
            name: "Action",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ width: '115px' }}>
                            <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={this.opSidePage('slide-menu-1', tableMeta.rowIndex, 'companyGroup')}
                                permission=""
                            >
                                <i className="fa fa-lw fa-pencil-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button>
                            {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
                            <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={this.opSidePage('slide-menu-view', tableMeta.rowIndex)}
                                permission=""
                            >
                                <i className="fa fa-lw fa-ellipsis-v"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button>
                        </div>
                    );
                }
            }
        }
    ];


    opSidePage = (menu, data) => (e) => {
        e.preventDefault()
        let selectedIndex = data
        this.setState({
            updateVisible: false,
        })

        switch (menu) {
            case 'slide-menu-1':
                this.setState({
                    updateVisible: true,
                    selectedIndex,
                    popupType: "update"
                })
                break
            case 'slide-menu-view':
                this.setState({
                    updateVisible: true,
                    selectedIndex,
                    popupType: "view"
                })
                break
            default:
                break
        }

    }
    resetTab = (tabIndex) => {
        this.setState({ tabIndex });
        if (tabIndex === 0) {
            this.getCountPage(this.state.table_page, this.state.table_limit);
        }
    }

    render() {
        if (R.isNil(this.props.auth.user)) return <Redirect to={{ pathname: "/" }} />
        let { toCount, table_query } = this.state
        let tableOptions = {
            ...options,
            serverSide: true,
            count: toCount,
            searchText: table_query,
            rowsPerPage: this.state.table_limit,
            page: this.state.table_page,
            onColumnSortChange: (changedColumn, direction) => {
                let order = 'desc';
                if (direction === 'ascending') {
                    order = 'asc';
                }

                let columnOrder = "";

                if (changedColumn === "Company") {
                    columnOrder = "companyCode";
                }

                if (changedColumn === "Username") {
                    columnOrder = "username";
                }

                if (changedColumn === "Email") {
                    columnOrder = "email";
                }

                if (changedColumn === "Category") {
                    columnOrder = "category";
                }

                if (changedColumn === "Employee Name") {
                    columnOrder = "name";
                }

                if (changedColumn === "Status") {
                    columnOrder = "status";
                }

                this.columnsUser.map((value, index) => {
                    if (changedColumn === value.name && value.name !== "Action") {
                        value.options = { sortDirection: order }
                    } else {
                        value.options = { ...value.options, sortDirection: "none" }
                    }
                })

                this.setState({
                    dataDto: {
                        ...this.state.dataDto,
                        sortBy: columnOrder,
                        orderBy: order
                    }
                }, () => {
                    this.getCountPage(this.state.table_page, this.state.table_limit);
                });
            },
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.setState({ table_page: tableState.page })
                        this.getCountPage(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.setState({ table_limit: tableState.rowsPerPage })
                        this.getCountPage(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'search':
                        let searchText = tableState.searchText ? tableState.searchText : ""
                        this.setState({ table_query: searchText }, () => {
                            this.handleSearch();
                        })
                        break;
                    default:
                        break;
                }
            }
        }
        return (
            <div className="main-slider">
                <div className="padding-tbl-monitoring">
                    <LoadingBar onRef={ref => (this.LoadingBar = ref)} />
                    <Tabs selectedIndex={this.state.tabIndex}
                        onSelect={(tabIndex) => this.resetTab(tabIndex)}>
                        <TabList>
                            <Tab>Bank</Tab>
                        </TabList>
                        <TabPanel>
                            <div
                                className='grid grid-4x grid-mobile-none gap-15px padding-top-15px'>
                                <div className='col-2'>
                                    <DDLCompany
                                        box={'search'}
                                        label={'Bank'}
                                        hierarchy={false}
                                        onChangeCombo={(value) => {
                                            this.setState({
                                                data: { ...this.state.data, ...value }
                                            })
                                        }}
                                        valueCombo={this.state.data.companyIdSelect}
                                    />
                                </div>
                                <div className='col-3 padding-top-25px'>
                                    <Button
                                        type='button'
                                        className='btn btn-circle background-red'
                                        style={{ marginRight: 5 }}
                                        onClick={() => this.handleSearch(true)}
                                        permission={this.state.buttonAccess.btnSearch}
                                    >
                                        <i className='fa fa-1x fa-search' />
                                    </Button>
                                    <Button
                                        type='button'
                                        className='btn btn-circle background-red'
                                        style={{ marginRight: 10 }}
                                        onClick={this.handleClearUser}
                                        permission={this.state.buttonAccess.btnClear}
                                    >
                                        <i className='fa fa-1x fa-sync-alt' />
                                    </Button>
                                </div>
                            </div>
                            <div>
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MUIDataTable
                                        key={toCount}
                                        title={'Bank List'}
                                        subtitle={"Setting data of Bank List"}
                                        data={this.state.dataTable}
                                        columns={this.columnsUser}
                                        options={tableOptions}
                                        buttonCreate={this.state.buttonAccess.btnAdd}
                                        onCreate={this.openCreateForm.bind(this)}
                                    />
                                </MuiThemeProvider>
                            </div>
                        </TabPanel>
                    </Tabs>
                </div>

                <div>
                    {this.state.createVisible && (
                        <FormBank
                            type={"create"}
                            loadSave={this.state.loadSave}
                            user={this.props.auth.user}
                            onClickClose={this.openCreateForm.bind(this)}
                            onClickSave={this.handleSubmit.bind(this)}
                        />
                    )}

                    {this.state.updateVisible && (
                        <FormBank
                            type={this.state.popupType === "update" ? "edit" : "view"}
                            data={this.state.rawData[this.state.selectedIndex]}
                            loadSave={this.state.loadSave}
                            user={this.props.auth.user}
                            onClickClose={this.openUpdateForm.bind(this)}
                            onClickSave={this.handleSubmit.bind(this)}
                        />
                    )}

                    {this.state.savePopUpVisible && (
                        <PopUp
                            type={"save"}
                            class={"app-popup app-popup-show"}
                            onClick={this.handlePopUp.bind(this)}
                        />
                    )}

                    {this.state.deletePopUpVisible && (
                        <PopUp
                            type={"delete"}
                            class={"app-popup app-popup-show"}
                            onClickDelete={this.handleDelete}
                            onClick={this.openDeletePopup}
                            isLoading={this.state.loadSave}
                        />
                    )}
                </div>

            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        masterdata: state.masterdata,
        auth: state.auth
    };
};

const mapDispatchToProps = dispatch => {
    return {
        authLogout: () => dispatch(AuthAction.authLogout())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Bank);